<button
  type="button"
  class="clickable-row"
  [class.clickable-row--disabled]="disabled() || loading()"
  [disabled]="disabled() || loading()"
  (click)="onButtonClick($event)"
>
  <span class="clickable-row__general">
    <i class="clickable-row__general-icon icon" [ngClass]="icon()"></i>
    <span class="clickable-row__general-label" [class.placeholder]="!label()">
      {{ label() || placeholder() }}
    </span>
  </span>

  <span class="clickable-row__arrow">
    @if (arrowLabel()) {
      <button
        class="clickable-row__arrow-label"
        [disabled]="arrowLabelDisabled() || disabled() || loading()"
        (click)="onArrowButtonClick($event)"
      >
        {{ arrowLabel() }}
      </button>
    }

    @if (loading()) {
      <span class="clickable-row__loader" aria-hidden="true"></span>
    } @else {
      <i
        class="clickable-row__arrow-icon icon icon-chevron-right"
        [class.open]="isOpen() != null && isOpen()"
      ></i>
    }
  </span>
</button>
